import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { provideState } from '@ngrx/store';
import { loginFeature } from './pages/login/store/reducers';
import { provideEffects } from '@ngrx/effects';
import { LoginEffects } from './pages/login/store/effects';
import { commonFeature } from './shared/store/reducers';
import { CommonEffects } from './shared/store/effects';
import { ticketsFeature } from './pages/tickets/store/reducers';
import { TicketsEffects } from './pages/tickets/store/effects';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.component').then((c) => c.HomeComponent),
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/home/home.routes').then((x) => x.routes),
    providers: [
      provideState(commonFeature),
      provideEffects(CommonEffects),
      provideState(ticketsFeature),
      provideEffects(TicketsEffects),
    ],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((x) => x.LoginComponent),
    providers: [
      provideState(loginFeature),
      provideEffects(LoginEffects),
      provideState(commonFeature),
      provideEffects(CommonEffects),
    ],
  },
  {
    path: 'chat',
    loadComponent: () =>
      import('./pages/chatbotwebapp/chatbotwebapp.component').then(
        (x) => x.ChatbotwebappComponent
      ),
    providers: [provideState(commonFeature), provideEffects(CommonEffects)],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login',
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
